import React = require('react')

import { navigateToRoute } from "../Component/navigation"
import { kolonne } from "../Component/components"
import { ListeComponent } from "../Component/ListeComponent"
import { ILoaderProps } from "../domene"

import Models = Gf.Web.Models;

export class PoliseTabell extends ListeComponent<Models.PoliseFeltType, Models.PoliseListeModell> {
    constructor(props: ILoaderProps) {
        super(props, "Polise", "Poliser", r => navigateToRoute(`/Polise/${r.EntitetId}`));
    }

    getKolonner(model: Models.PoliseListeModell) {
        return [
            kolonne(model, Models.PoliseFeltType.PoliseNr, "20%"),
            kolonne(model, Models.PoliseFeltType.Pris, "20%"),
            kolonne(model, Models.PoliseFeltType.PoliseStatus, "20%"),
            kolonne(model, Models.PoliseFeltType.UtstederRegion, "20%"),
            kolonne(model, Models.PoliseFeltType.UtstedtDato, "20%")
        ];
    }
}



// WEBPACK FOOTER //
// ./Scripts/React/Polise/PoliseTabell.tsx